import AffiliateShoppingLayout from "@app/layouts/AffiliateShopping/AffiliateShoppingLayout";
import ErrorLayout from "@app/layouts/ErrorLayout/ErrorLayout";
import { AffiliateShoppingData } from "@app/types/ServerCustomContext";
import AdSettings from "@app/utils/AdSettings";
import MetaData from "@components/Modules/MetaData";
import {
  mapErrorDataToMetaData,
  mapStaticContentDataToMetaData,
} from "@components/Modules/MetaData/mappers";
import PubBaseLayout from "@pub/BaseLayout";
import { configAffiliateShopping } from "@pub/config";
import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import { useLoaderData, useLocation } from "react-router";

export const meta = ({
  loaderData,
  location,
}: {
  loaderData: TRouteWithRedirect<AffiliateShoppingData, string>;
  location: { pathname: string };
}) => {
  if (loaderData.type !== ResponseType.SUCCESS) {
    const errorData = mapErrorDataToMetaData(loaderData, location);
    return MetaData(errorData);
  }

  const payload = loaderData.payload;
  const metaData = mapStaticContentDataToMetaData(payload);

  return MetaData(metaData);
};

export default function AffiliateShopping() {
  const response: TRouteWithRedirect<AffiliateShoppingData, string> =
    useLoaderData();
  const location = useLocation();

  if (response.type !== ResponseType.SUCCESS) {
    return <ErrorLayout response={response} />;
  }

  const affiliateShoppingData = response.payload;

  return (
    <PubBaseLayout>
      <AdSettings
        pageType="category"
        sectionName="Affiliate Shopping"
        adUnits="lb1,lb2,imu1,imu2,catfish,prestitial"
        pageTitle="Affiliate Shopping"
        currentLocation={location}
      />
      <AffiliateShoppingLayout
        data={{
          heading: affiliateShoppingData.headline,
          headingZH: affiliateShoppingData.headlineZH,
          showVerticalLine: configAffiliateShopping.withDivider,
          blocks: affiliateShoppingData.blocks,
          uniqSectionName: affiliateShoppingData.uniqSectionName,
          standFirst: affiliateShoppingData.standfirst,
          displaySetting: affiliateShoppingData.displaySetting,
        }}
      />
    </PubBaseLayout>
  );
}
